import { render, staticRenderFns } from "./BaseCount.vue?vue&type=template&id=2adc6169&"
import script from "./BaseCount.vue?vue&type=script&lang=js&"
export * from "./BaseCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports